module.exports = "https://r.nearpod.com/assets/media/image/header-logo-d462df97b79301f432a794edbe60cbc2.svg";